import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMessageTextCircle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12c0 1.328.26 2.598.732 3.76l.084.211.005.014-.001.005a7.06 7.06 0 0 1-.03.183l-.597 3.587c-.027.16-.057.34-.069.496-.013.17-.017.44.106.727a1.5 1.5 0 0 0 .787.787c.286.123.557.119.727.106.156-.012.336-.042.496-.069l3.587-.598.183-.029h.005l.014.005c.045.016.105.04.21.083A9.973 9.973 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2ZM8 8.5a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H8ZM8 12a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H8Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgMessageTextCircle02.displayName = 'MessageTextCircle02';
export default SvgMessageTextCircle02;
